import React from 'react';
import { withFormik } from "formik";
import Box from '@mui/material/Box';
import withProps from "recompose/withProps";
import StyleWrap from "../../utils/style/Style";
import QrValueMap from "@xem/qr-common/classes/QrValueMap";
import { getSvg } from "@gqlapp/qrcode/Render";

const QrViewWithForm = withFormik({
	enableReinitialize: true,
	displayName: `QrViewForm`,
	mapPropsToValues: ({ values }) => values
});


const QrViewWithRef = React.forwardRef((props, ref) => {

	const WithForm = QrViewWithForm((props)=>{
		const setValues =  props?.setValues;
		const setFieldValue = props?.setFieldValue;

		React.useImperativeHandle(ref, () => ({ setValues, setFieldValue }));

		const QRView = withProps(({ values, values: { data_text } }) => {
			try {
				return { renderer: getSvg({ text: data_text, input: values }) }
			}catch (e) {
				console.warn(e)
			}
		})(({ renderer, viewStyle: style, className, style:{ ...rest } = {} }) => {
			let Style = props?.styleWrap || StyleWrap
			return (<Box {...{ style, className}} sx={{ position: 'relative' }}>
				<Style {...{...rest, renderer}} />
			</Box>)
		});
		
		return <QRView {...props} />
	});
	
	return <WithForm {...props} />
});

export default QrViewWithRef;
